import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="BATSU GAME de Yankee Onna ni Kokuttemita parte 1"
      portada="https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-1.jpg"
      paginas={[
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-2.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-3.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-4.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-5.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-6.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-7.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-8.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-9.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-10.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-11.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-12.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-13.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-14.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-15.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-16.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-17.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-18.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-19.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-20.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-21.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-22.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-23.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-24.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-25.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-26.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-27.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-28.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-29.jpg"
]}


      sugeridos={[]}


      info={{
      grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [""],
etiquetas: ["Ahegao", "Ball Sucking", "Big Ass", "Big Breasts", "Big Nipples", "Big Penis", "Blackmail", "Blowjob", "Condom", "Defloration", "Digital", "Filming", "Freckles", "Gyaru", "Huge Breasts", "Kissing", "Leg Lock", "Mind Break", "Multi-work Series", "Netorare", "Ponytail", "Schoolgirl Uniform", "Sole Female", "Sole Male", "Squirting", "Stockings", "Tall Girl", "Tomboy", "Virginity", "Voyeurism"],        artistas: "Fuetakishi",
      }}
    />
  );
}

export const infoManga = {
  titulo: "BATSU GAME de Yankee Onna ni Kokuttemita parte 1",
  portada: "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-1.jpg",
  reverso: "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita1-11.jpg",
        fecha:"2026-05-16",


  info: {
  grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [""],
etiquetas: ["Ahegao", "Ball Sucking", "Big Ass", "Big Breasts", "Big Nipples", "Big Penis", "Blackmail", "Blowjob", "Condom", "Defloration", "Digital", "Filming", "Freckles", "Gyaru", "Huge Breasts", "Kissing", "Leg Lock", "Mind Break", "Multi-work Series", "Netorare", "Ponytail", "Schoolgirl Uniform", "Sole Female", "Sole Male", "Squirting", "Stockings", "Tall Girl", "Tomboy", "Virginity", "Voyeurism"],
    artistas: "Fuetakishi",
  },
};
